import * as apiDelete from 'api/timeUnit/DeleteTimeUnitIdV1';
import * as apiRestore from 'api/timeUnit/PostTimeUnitRestoreV1';
import * as apiPostSearch from 'api/timeUnit/PostTimeUnitSearchV1';

export default class TimeUnit {
	public id: string = '';
	public name: string = '';

	public constructor(input?: apiPostSearch.ResponseTimeUnit) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiDelete(): Promise<void> {
		await apiDelete.callApi(this.id);
	}

	public async callApiRestore(): Promise<void> {
		await apiRestore.callApi(this.id);
	}

	private mapFromApi(input: apiPostSearch.ResponseTimeUnit) {
		this.id = input.id;
		this.name = input.name;
	}
}
